/**
 * @Author: v_jppjpeng
 * @Date: 2022-09-22 16:13:06
 * @Explain: 数据报表
 */

export default {
  'DATA.REPORT.ACTIVITY.TYPE.EXPLAIN.TIPS1':
    'Requests sent, Requests approved, Emails sent, Emails opened, Contacts unsubscribed, Contacts registered',
  'DATA.REPORT.ACTIVITY.TYPE.EXPLAIN.TIPS2':
    'Requests sent, Requests approved, Emails sent, Emails opened, Contacts unsubscribed, Active contacts',
  'DATA.REPORT.ACTIVITY.TYPE.EXPLAIN.TIPS3':
    'Requests sent, Requests approved, Emails sent, Emails opened, Contacts unsubscribed, Paying contacts',
  'DATA.REPORT.ACTIVITY.TYPE.EXPLAIN.TIPS4':
    'Requests sent, Requests approved, Emails sent, Emails opened, Contacts unsubscribed',
  'DATA.REPORT.RENEW': 'Acquisition',
  'DATA.REPORT.INVIGORATE': 'Activation',
  'DATA.REPORT.PAY': 'Payment',
  'DATA.REPORT.ACTIVITY.DESC.LIST': [
    {
      label: 'Acquisition',
      content: [
        '<p>This type of campaign shows data statistics such as the number of registered users</p>',
      ],
    },
    {
      label: 'Activation',
      content: [
        '<p>This type of campaign shows data statistics such as the number of active users</p>',
      ],
    },
    {
      label: 'Payment',
      content: [
        '<p>This type of campaign shows data statistics such as the number of paid users</p>',
      ],
    },
  ],
  'DATA.REPORT.TYPE': 'Type',
  'DATA.REPORT.VALUE': 'Value',
  // 'DATA.REPORT.DATA.BASE.INFO': 'Campaign information',
  'DATA.REPORT.DATA.OVERVIEW': 'Overview',
  'DATA.REPORT.GENERAL.TITLEINFO.TITLE': 'Explanation of data overview',
  'DATA.REPORT.GENERAL.SUBTITLE.1': 'Data change trend',
  'DATA.REPORT.GENERAL.SUBTITLE.2': 'Reach and Conversion Statistics',
  'DATA.REPORT.FUNNEL.CHART': 'Funnel chart',
  'DATA.REPORT.GENERAL.DESC.LIST': [
    {
      label: 'Sent requests',
      content: [
        '<small>Number of emails sent by the system</small>',
        '<p>The system will filter out the email addresses of unsubscribed players.</p>',
      ],
    },
    // {
    //   label: 'Actual sending quantity',
    //   content: ['<small>Number of emails received by the downstream</small>', '<p>The downstream will verify the email address formats and blocklist for filtration.</p>'],
    // },
    {
      label: 'Successful deliveries',
      content: [
        "<small>Number of emails delivered to user's email servers</small>",
        "<p>User's email servers will determine whether to reject an email based on the anti-spam policy.</p>",
      ],
    },
    {
      label: 'E-mails total clicks',
      content: ['<small>Number of unique emails opened by users</small>'],
    },
    {
      label: 'Link clicks',
      content: [
        '<small>Registered users</small>',
        '<p>Number of unique users with the time of registering the game (first login to the game) later than the time of sending emails to the users. Only the data within 7 days is displayed.</p>',
      ],
    },
    {
      label: '',
      content: [
        '<small>Active Users</small>',
        '<p>Number of unique users with the time of login to the game later than the time of sending emails to the users. Only the data within 7 days is displayed.</p>',
      ],
    },
    {
      label: '',
      content: [
        '<small>Paying users</small>',
        '<p>Number of unique users with the in-game payment time later than the time of sending emails to the users. Only the data within 7 days is displayed.</p>',
      ],
    },
    {
      label: 'E-mails rejected deliveries',
      content: [
        '<small>Number of users who have unsubscribed from emails</small>',
        '<p>When the emails of multiple campaigns A, ..., B are sent in sequence and the same user is included in all these campaigns, after the user unsubscribe, the data will be recorded in the last outreach campaign "B" before the unsubscription. This metric varies with user unsubscription and resubscription.</p>',
      ],
    },
  ],
  'DATA.REPORT.DELIVERY.VOLUME': 'E-mails delivered',
  'DATA.REPORT.DELIVERY.VOLUME.1': 'Clicked',
  'DATA.REPORT.DELIVERY.VOLUME.2': 'Not delivered',
  'DATA.REPORT.DELIVERY.VOLUME.3': 'Not opened',
  'DATA.REPORT.DELIVERY.VOLUME.4': 'Not clicked',
  'DATA.REPORT.RATIO': 'Rates',
  'DATA.REPORT.RATIO.TITLEINFO.TITLE':
    'Outreach conversion comparison descriptionComparison of Reach and Conversion',
  'DATA.REPORT.RATIO.DESC.LIST': [
    {
      label: 'Delivered rate',
      content: [
        '<p>Number of emails delivered on the day/Number of requests approved on the day</p>',
      ],
    },
    {
      label: 'Opened rate',
      content: [
        '<p>among the emails sent successfully on the day/Number of emails delivered on the day</p>',
      ],
    },
    {
      label: 'Bounced rate',
      content: [
        '<p>Number of unsubscribed users to who emails were sent successfully on the day/Number of emails sent successfully on the day</p>',
      ],
    },
    {
      label: 'Registration conversion rate',
      content: [
        '<p>Number of the email addresses of players who have registered an account of the game and to who emails were sent successfully on the day/Number of emails sent successfully on the day</p>',
      ],
    },
    {
      label: 'Activation conversion rate',
      content: [
        '<p>Number of the email addresses of players who have logged in to the game and to who emails were sent successfully on the day/Number of emails sent successfully on the day</p>',
      ],
    },
    {
      label: 'Payment conversion rate',
      content: [
        '<p>Number of email addresses of paying players to who emails were sent successfully on the day/Number of emails sent successfully on the day</p>',
      ],
    },
  ],
  'DATA.REPORT.SELECT.EVENT': 'Select a campaign',
  'DATA.REPORT.SELECT.ACTIVITY.TYPE': 'Select a campaign type',
  'DATA.REPORT.SELECT.ACTIVITY.CYCLE': 'Select the campaign period',
  'DATA.REPORT.SELECT.LANGUAGE': 'Select a language',
  'DATA.REPORT.PLEASE.SELECT.PERIOD': 'Select period',
  'DATA.REPORT.PLEASE.SELECT.DATE': 'Select time',
  'DATA.REPORT.ALL.LANGUAGE': 'All languages',
  'DATA.REPORT.SELECT.REGION': 'Select a region',
  'DATA.REPORT.ALL.REGION': 'All regions',
  'DATA.REPORT.DETAIL': 'Details',
  'DATA.REPORT.DATE': 'Date of delivery',
  'DATA.REPORT.DATE.ERRORINFO':
    'The time period cannot exceed 1 month, please select again',

  // 邮件打开分析
  'DATA.REPORT.MAIL.OPEN.ANALYSIS': 'Email open analysis',
  'DATA.REPORT.MAIL.DELIVERY.DAY': '{num} days',
  'DATA.REPORT.DELIVERY.DAY':
    'Openings/Open volume on {num} days after delivery',
  'DATA.REPORT.MAIL.DELIVERY.DAY.TIPS':
    'Email opening statistics for {num} days after delivery',
  'DATA.REPORT.MAIL.OPEN.DATE': 'Email opening date',
  'DATA.REPORT.CUMULATIVE.OPEN.QUANTITY': 'Cumulative number of emails opened',
  'DATA.REPORT.CUMULATIVE.OPEN.RATE': 'Cumulative rate of opened emails ',

  // 注册数据分析
  'DATA.REPORT.REGIST.DATA.ANALYSIS': '{name} data analysis',
  'DATA.REPORT.REGIST.DATA.GEN.DATE':
    'Emails delivered/Registration data generation date',
  'DATA.REPORT.CUMULATIVE.REGIST': 'Cumulative registrations',
  'DATA.REPORT.CUMULATIVE.REGIST.RATE': 'Cumulative registration rate',

  'DATA.REPORT.ANALYSIS.TITLE.1': '7-day registration statistics',
  'DATA.REPORT.ANALYSIS.TITLE.2': '7-day active users statistics',
  'DATA.REPORT.ANALYSIS.TITLE.3': '7-day paying users statistics',

  'DATA.REPORT.ANALYSIS.ICON.1':
    'Daily statistics of users who registered for the game within 7 days after email was delivered',
  'DATA.REPORT.ANALYSIS.ICON.2':
    'Daily statistics of users who returned to log in to the game within 7 days after email was delivered',
  'DATA.REPORT.ANALYSIS.ICON.3':
    'Daily statistics of users who paid in the game within 7 days after email was delivered',

  'DATA.REPORT.CUMULATIVE.USER.NUM.1': 'Cumulative registered users',
  'DATA.REPORT.CUMULATIVE.USER.NUM.2': 'Cumulative active users',
  'DATA.REPORT.CUMULATIVE.USER.NUM.3': 'Cumulative paying users',

  'DATA.REPORT.CUMULATIVE.RATE.1':
    'Cumulative registration rate (number of registered users / total delivered volume)',
  'DATA.REPORT.CUMULATIVE.RATE.2':
    'Cumulative active rate (number of returning users who logged into the game / total delivered volume)',
  'DATA.REPORT.CUMULATIVE.RATE.3':
    'Cumulative paying rate (number of paying users / total delivered volume)',

  // 当日发送邮件数据汇总
  'DATA.REPORT.CURRENT.DAY.SUM': 'Daily statistics',

  // v2.1.0 ----------start----------
  // Tab1
  'DATA.REPORT.OVERVIEW.TOTAL.SENT.VOLUME': 'Sending volume',
  'DATA.REPORT.OVERVIEW.TOTAL.SENT.VOLUME.SUBTITLE.1': 'Sending trend',
  'DATA.REPORT.OVERVIEW.CARD': 'Metrics',
  'DATA.REPORT.GENERAL.DATA.1': 'Sent',
  'DATA.REPORT.GENERAL.DATA.2': 'Accepted',
  'DATA.REPORT.GENERAL.DATA.3': 'Delivered',
  'DATA.REPORT.GENERAL.DATA.4': 'Opened',
  'DATA.REPORT.GENERAL.DATA.5': 'Registered users',
  'DATA.REPORT.GENERAL.DATA.6': 'Active users',
  'DATA.REPORT.GENERAL.DATA.7': 'Paying users',
  'DATA.REPORT.GENERAL.DATA.8': 'Unsubscribed',
  'DATA.REPORT.GENERAL.DATA.9': 'Clicked',
  'DATA.REPORT.GENERAL.DATA.10': 'Recipients',
  'DATA.REPORT.GENERAL.TIPS.1': 'Number of emails sent',
  'DATA.REPORT.GENERAL.TIPS.2': '',
  'DATA.REPORT.GENERAL.TIPS.3': 'Delivery Rate = Delivered / Sent',
  'DATA.REPORT.GENERAL.TIPS.4': 'Open Rate = Opened / Delivered',
  'DATA.REPORT.GENERAL.TIPS.5':
    'Registration Rate = Registered users  / Delivered',
  'DATA.REPORT.GENERAL.TIPS.6': 'Activation Rate = Active users / Delivered',
  'DATA.REPORT.GENERAL.TIPS.7': 'Paying Users Rate = Paying users / Delivered',
  'DATA.REPORT.GENERAL.TIPS.8': 'Unsubscribe Rate = Unsubscribes / Delivered',
  'DATA.REPORT.GENERAL.TIPS.9': 'Click Rate = Clicked / Delivered',
  'DATA.REPORT.GENERAL.RATE.1': 'Filtered',
  'DATA.REPORT.GENERAL.RATE.INFO.1':
    '{num} recipients filtered in SmartLink <span class="color-primary">blocklist</span>',
  'DATA.REPORT.GENERAL.RATE.INFO.2':
    '{num} contacts filtered from the <span class="color-primary">blocklist</span> on SmartLink',
  'DATA.REPORT.GENERAL.RATE.INFO.1.L':
    '{num} subscriber(s) filtered out by SmartLink ',
  'DATA.REPORT.GENERAL.RATE.INFO.1.C': 'Blocklist',
  'DATA.REPORT.GENERAL.RATE.INFO.1.R': '',
  'DATA.REPORT.GENERAL.RATE.INFO.2.L':
    '{num} subscriber(s) filtered out by SmartLink ',
  'DATA.REPORT.GENERAL.RATE.INFO.2.C': 'Blocklist',
  'DATA.REPORT.GENERAL.RATE.INFO.2.R': '',

  'DATA.REPORT.GENERAL.RATE.2': '',
  'DATA.REPORT.GENERAL.RATE.3': 'Delivery Rate',
  'DATA.REPORT.GENERAL.RATE.4': 'Open Rate',
  'DATA.REPORT.GENERAL.RATE.5': 'Registration Rate',
  'DATA.REPORT.GENERAL.RATE.6': 'Activation Rate',
  'DATA.REPORT.GENERAL.RATE.7': 'Paying Users Rate',
  'DATA.REPORT.GENERAL.RATE.8': 'Unsubscribe Rate',
  'DATA.REPORT.GENERAL.RATE.9': 'Click Rate',
  'DATA.REPORT.GENERAL.RATE.10': 'Recipients',
  'DATA.REPORT.GENERAL.DESC.1': 'Number of emails sent',
  'DATA.REPORT.GENERAL.DESC.2': '',
  'DATA.REPORT.GENERAL.DESC.3':
    "Number of messages successfully delivered to users' email server",
  'DATA.REPORT.GENERAL.DESC.4': 'Number of emails opened',
  'DATA.REPORT.GENERAL.DESC.5':
    'Number of registrations out of total number of delivered emails',
  'DATA.REPORT.GENERAL.DESC.6':
    'Number of logins out of total number of delivered emails',
  'DATA.REPORT.GENERAL.DESC.7':
    'Number of paying users out of total number of delivered emails',
  'DATA.REPORT.GENERAL.DESC.8': 'Number of unsubscribes from this campaign',
  'DATA.REPORT.GENERAL.DESC.9': 'Number of emails where the link was clicked',
  'DATA.REPORT.GENERAL.DESC.10':
    'The total number of recipients based on campaign settings',
  'DATA.REPORT.GENERAL.DATA.ADD': 'Add in-game metrics',
  'DATA.REPORT.GENERAL.DATA.CHANGE': 'Change',
  // Delivery Analusis
  'DATA.REPORT.DELIVERY.ANALUSIS': 'Delivery Analysis',
  'DATA.REPORT.GENERAL.DELIVERY.RATE.TITLE': 'Delivery rate',
  'DATA.REPORT.GENERAL.OPEN.RATE.TITLE': 'Open rate',
  'DATA.REPORT.GENERAL.CLICK.RATE.TITLE': 'Click rate',
  'DATA.REPORT.GENERAL.UNSUB.RATE.TITLE': 'Unsubscribe rate',
  'DATA.REPORT.GENERAL.DATA.allRegister': 'Registration',
  'DATA.REPORT.GENERAL.TIPS.allRegister':
    'Registration Rate = Registrations / Deliveries',
  'DATA.REPORT.GENERAL.RATE.allRegister': 'Registration Rate',
  'DATA.REPORT.GENERAL.DATA.allActive': 'Activation',
  'DATA.REPORT.GENERAL.TIPS.allActive':
    'Activation Rate = Number of Active / Delivery',
  'DATA.REPORT.GENERAL.RATE.allActive': 'Activation Rate',
  'DATA.REPORT.GENERAL.DATA.allPayCount': 'Payment',
  'DATA.REPORT.GENERAL.TIPS.allPayCount':
    'Paying Users Rate = Number of Payments / Delivery',
  'DATA.REPORT.GENERAL.RATE.allPayCount': 'Paying Users Rate',
  'DATA.REPORT.DELIVERY.CLICKED.ANALYSIS.TITLE': 'Email Click Analysis',
  'DATA.REPORT.DELIVERIED': 'Date of delivery',
  'DATA.REPORT.DELIVERIED.OPEN.EMAILS.NUM':
    'Cumulative number of emails clicked',
  'DATA.REPORT.DELIVERIED.OPEN.EMAILS.RATE':
    'Cumulative rate of clicked emails',
  'DATA.REPORT.DELIVERIED.DELIVERED.RATE': 'Delivered rate',
  'DATA.REPORT.DELIVERIED.OPEN.RATE': 'Open rate',
  'DATA.REPORT.DELIVERIED.CLICK.RATE': 'Click-to-Open Rate (CTOR) ',
  'DATA.REPORT.DELIVERIED.UNSUB.RATE': 'Unsubscribe rate',
  'DATA.REPORT.DELIVERIED.DELIVERED': 'Delivered',
  'DATA.REPORT.DELIVERIED.SENT': 'Sent',
  'DATA.REPORT.DELIVERIED.OPEN': 'Opened',
  'DATA.REPORT.DELIVERIED.CLICK': 'Clicked',
  'DATA.REPORT.DELIVERIED.OPENED': 'Opened',
  'DATA.REPORT.DELIVERIED.UNSUB': 'Unsuscribed',
  // In-game Behavior Analusis
  'DATA.REPORT.IN.GAME.BEHAVIOR.ANALUSIS': 'In-game Behavior Analysis',
  'DATA.REPORT.IN.GAME.BEHAVIOR.REG.COM.RATE': 'Registration rate',
  'DATA.REPORT.IN.GAME.BEHAVIOR.NEW.REGISTERED.USER': 'New registered user',
  'DATA.REPORT.IN.GAME.BEHAVIOR.ACTIVATION.RATE': 'Activation rate',
  'DATA.REPORT.IN.GAME.BEHAVIOR.NEW.ACTIVATION.USER': 'New active user',
  'DATA.REPORT.IN.GAME.BEHAVIOR.PAYMENT.RATE': 'Paying Users Rate',
  'DATA.REPORT.IN.GAME.BEHAVIOR.NEW.PAYMENT.USER': 'New paying user',
  'DATA.REPORT.IN.GAME.BEHAVIOR.LINE.TITLE.1': 'Registration rate',
  'DATA.REPORT.IN.GAME.BEHAVIOR.LINE.TITLE.2': 'Activation rate',
  'DATA.REPORT.IN.GAME.BEHAVIOR.LINE.TITLE.3': 'Paying Users Rate',
  // 'DATA.REPORT.IN.GAME.BEHAVIOR.LINE.TITLE.1': 'Newly registered users after delivery',
  // 'DATA.REPORT.IN.GAME.BEHAVIOR.LINE.TITLE.2': 'New active users after delivery',
  // 'DATA.REPORT.IN.GAME.BEHAVIOR.LINE.TITLE.3': 'New paying users after delivery',
  // 动态指标 modal
  'DATA.REPORT.DYNAMIC.INDICATORCARD.DOCS':
    'You can add in-game metadata to track the performance of your campaign by synchronising in-game data through the APl. For more information, see <a href="{ url }" target="_blank">API Reference</a>.',
  'DATA.REPORT.DYNAMIC.INDICATORCARD.NOTED': 'Note:',
  'DATA.REPORT.DYNAMIC.INDICATORCARD.NOTED.DESC':
    'This indicator <b>only</b> counts players included in the campaign.',
  'DATA.REPORT.DYNAMIC.INDICATORCARD.FORM.TITLE':
    'Depending on the purpose of the campaign, choose the metric you want to follow.',
  'DATA.REPORT.DYNAMIC.INDICATORCARD.FORM.LABEL.1': 'Registered user',
  'DATA.REPORT.DYNAMIC.INDICATORCARD.FORM.LABEL.1.DESC':
    'Pull reg_time, openid, country, language, email data through register, userinfo interface.',
  'DATA.REPORT.DYNAMIC.INDICATORCARD.FORM.LABEL.2': 'Active user',
  'DATA.REPORT.DYNAMIC.INDICATORCARD.FORM.LABEL.2.DESC':
    'Pull login_time, openid, country, language, level data through login interface.',
  'DATA.REPORT.DYNAMIC.INDICATORCARD.FORM.LABEL.3': 'Paying user',
  'DATA.REPORT.DYNAMIC.INDICATORCARD.FORM.LABEL.3.DESC':
    'Pull pay_time, openid, billing_id data through pay interface.',
  'DATA.REPORT.DYNAMIC.INDICATORCARD.FORM.Add': 'Add',
  'DATA.REPORT.DYNAMIC.INDICATORCARD.FORM.DIS': 'No data, please access first',
  // 告警线
  'DATA.REPORT.WARNNING.LINE': 'warning line',
  'DATA.REPORT.BENCHMARK.LINE': 'benchmark line',
  'DATA.REPORT.FILTER.TIME.OPTIONS.7': 'Last 7 days',
  'DATA.REPORT.FILTER.TIME.OPTIONS.14': 'Last 14 days',
  'DATA.REPORT.FILTER.TIME.OPTIONS.30': 'Last 30 days',
  'DATA.REPORT.FILTER.TIME.OPTIONS.90': 'Last 90 days',
  'DATA.REPORT.FILTER.TIME.OPTIONS.CUSTOME': 'Custom range',
  'DATA.REPORT.FILTER.TIME.OPTIONS.GRAININESS.DAY': 'by day',
  'DATA.REPORT.FILTER.TIME.OPTIONS.GRAININESS.HOUR': 'by hour',
  'DATA.REPORT.FILTER.LANGUAGE.AND.LOCATION': 'Language & Region',

  // Delivery status
  'DATA.REPORT.DELIVERY.STATUS.TITLE': 'Delivery failed',
  'DATA.REPORT.DELIVERY.STATUS.TABLE.COMPONENT': 'Action',
  'DATA.REPORT.DELIVERY.STATUS.TABLE.NUMBER': 'Count (number)',
  'DATA.REPORT.DELIVERY.STATUS.TABLE.SHARE': 'Ratio (percentage)',
  'DATA.REPORT.DELIVERY.STATUS.TABLE.COLUMNS.FILTER': 'Filter',
  'DATA.REPORT.DELIVERY.STATUS.TABLE.COLUMNS.BOUNCE.HARD': 'Bounce (hard)',
  'DATA.REPORT.DELIVERY.STATUS.TABLE.COLUMNS.BOUNCE.SOFT': 'Bounce (soft)',
  'DATA.REPORT.DELIVERY.STATUS.TABLE.COLUMNS.SUCCESSFUL.DELIVERY':
    'Delivered successfully',
  'DATA.REPORT.DELIVERY.STATUS.TABLE.COLUMNS.TOTAL': 'Total',
  'DATA.REPORT.DELIVERY.STATUS.TABLE.INFO.TEXT':
    'Blocklisted emails will be filtered out automatically and hard bounced emails will be added to the blocklist automatically. (You can manage your ',
  'DATA.REPORT.DELIVERY.STATUS.TABLE.INFO.LINK': 'blocklist',
  'DATA.REPORT.DELIVERY.STATUS.TABLE.INFO.OVER': ' in project settings)',
  'DATA.REPORT.OVERVIEW.CILCK.MODAL.TITLE': 'Click performance',
  'DATA.REPORT.OVERVIEW.CILCK.MODAL.TABLE.COLUMNS.TITLE': 'Title',
  'DATA.REPORT.OVERVIEW.CILCK.MODAL.TABLE.COLUMNS.REMARK': 'Notes',
  'DATA.REPORT.OVERVIEW.CILCK.MODAL.TABLE.COLUMNS.URL': 'URL',
  'DATA.REPORT.OVERVIEW.CILCK.MODAL.TABLE.COLUMNS.TOTAL.CLICKS': 'Total clicks',
  'DATA.REPORT.OVERVIEW.CILCK.MODAL.TABLE.COLUMNS.UNIQUE.CLICKS':
    'Unique clicks',
  'DATA.REPORT.OVERVIEW.DELIVERY.STATUS.PIE.TOLLTIP.NUMBER': 'Count',
  'DATA.REPORT.OVERVIEW.DELIVERY.STATUS.PIE.TOLLTIP.SHARE': 'Total',
};
